/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {releaseRestriction} from '../api'

export const useMutationReleaseRestriction = createReactQueryMutationHook('releaseRestriction', releaseRestriction)
